import React from 'react';
import {useSelector} from 'react-redux';
import {useState, useEffect} from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
} from 'react-bootstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import TimePickerComponent from 'components/DateTime/TimePicker';
import MulptipleDatePickerComponent from 'components/DateTime/MultipleDatePicker';
import DNS from 'components/DNS/dns.js';
import NotificationAlert from 'react-notification-alert';
import axios from 'components/Axios/Axios';
import CircularProgress from '@mui/material/CircularProgress';
import 'assets/css/icone_in_input.css';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
import {FaTimes} from 'react-icons/fa';


const ModalADDTableList = ({showModal, setShowModal, showTodayDate, showMaxdayDate, getAppointment, showVisitorEmailRequired}) => {
  const {t} = useTranslation();
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const user = useSelector((state) => state.user);

  const [showVFirstName, setVFirstName] = useState('');
  const [showVLastName, setVLastName] = useState('');
  const [showVEmail, setVEmail] = useState('');
  const [showVEntreprise, setVEntreprise] = useState('');
  const [showLanguageMail, setLanguageMail] = useState({'value': 'fr', 'label': t(translations.LANGUAGE_MAIL_FR)});
  const [noEmailChecked, setNoEmailChecked] = useState(false);
  // const [showVisitor, setVisitor] = useState('');
  const [showHour, setHour] = useState('');
  const [showDate, setDate] = useState([]);
  const [showComments, setComments] = useState('');
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAddAgain, setAddAgain] = useState(false);
  const animatedComponents = makeAnimated();

  const handleSubmit = (event) => {
    if (showVFirstName == '' || showVLastName == '' || showHour == '' || showDate == [] || (showVisitorEmailRequired == true && showVEmail == '')) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  const resetValues = () => {
    setLoading(false);
    setValidated(false);
    setNoEmailChecked(false);
    setHour('');
    setDate([]);
    setComments('');
    setVLastName('');
    setVFirstName('');
    setVEmail('');
    setVEntreprise('');
    setLanguageMail({'value': 'fr', 'label': t(translations.LANGUAGE_MAIL_FR)});
  };


  useEffect(() => {
    if (showLanguageMail.value === 'fr') {
      setLanguageMail({value: 'fr', label: t(translations.LANGUAGE_MAIL_FR)});
    } else if (showLanguageMail.value === 'en') {
      setLanguageMail({value: 'en', label: t(translations.LANGUAGE_MAIL_EN)});
    }
  }, [t]);

  const notificationAlertRef = React.useRef(null);
  const notify = (place, txt, typeNot, iconNot) => {
    const type = typeNot;
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{txt}</p>
          </div>
        </div>
      ),
      type: type,
      icon: iconNot,
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const resetValuesToAddAnother = () => {
    setLoading(false);
    setValidated(false);
    setAddAgain(false);
    setVLastName('');
    setVFirstName('');
    setVEmail('');
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return ''; // Handle empty or null strings
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const createAppointment = (event) => {
    event.preventDefault();
    const formatFirstName = showVFirstName[0].toUpperCase() + showVFirstName.slice(1);
    const fullname = showVLastName.toUpperCase() + ' ' + formatFirstName;
    const formattedDates = [];

    showDate.forEach((entry) => {
      console.log('entry', entry);

      if (Array.isArray(entry)) {
        const [startObj, endObj] = entry;

        if (startObj?.toDate && endObj?.toDate) {
          const start = startObj.toDate();
          const end = endObj.toDate();

          const formattedStart = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}-${String(start.getDate()).padStart(2, '0')}`;
          const formattedEnd = `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}`;

          formattedDates.push([formattedStart, formattedEnd]);
        } else if (startObj?.toDate) {
          const start = startObj.toDate();
          const formattedStart = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}-${String(start.getDate()).padStart(2, '0')}`;
          formattedDates.push([formattedStart, formattedStart]);
        }
      }
    });
    const requestOptionsAxiosHeaders = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'token ' + token['tokenRedux'],
      },
    };
    const requestOptions = {
      'pkBuilding': currentBuilding['currentbuildingRedux'].pk,
      'name': user['user'].firstName + ' ' + user['user'].lastName,
      'first_name_collab': user['user'].firstName,
      'last_name_collab': user['user'].lastName,
      'appointmentStatus': 'waiting',
      'time': showHour.getHours() + ':' + showHour.getMinutes(),
      'date': formattedDates,
      'visitor': fullname,
      'first_name_visitor': capitalizeFirstLetter(showVFirstName),
      'last_name_visitor': showVLastName.toUpperCase(),
      'companyName': user['user'].nameEntreprise,
      'email': user['user'].email,
      'visitor_email': showVEmail == '' ? 'email@email.com' : showVEmail,
      'visitor_entreprise': showVEntreprise,
      'commentaire': showComments,
      'language_mail': showLanguageMail.value,
    };
    setLoading(true);
    axios.post(DNS + '/list/createAppointment/',
        JSON.stringify(requestOptions),
        requestOptionsAxiosHeaders,
    )
        .then((response) => {
          setLoading(false);
          if (showAddAgain == false) {
            setShowModal(false);
            resetValues();
          } else {
            resetValuesToAddAnother();
          }
          notify('tc', t(translations.APPOINTMENT_CONFIRM), 'success', 'nc-icon nc-check-2');
          getAppointment();
          return;
        }).catch((error)=>{
          setLoading(false);
          notify('tc', t(translations.APPOINTMENT_ERROR), 'danger', 'nc-icon nc-simple-remove');
        });
  };

  const handleIconClick = () => {
    setVEmail('email@email.com');
    if (showVisitorEmailRequired) {
      notify('tc', t(translations.APPOINTMENT_INFO_DNA), 'warning', 'nc-icon nc-check-2');
    }
    // else {
    //   notify('tc', t(translations.APPOINTMENT_INFO), 'warning', 'nc-icon nc-check-2');
    // }
  };

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <Modal
        className="modal modal-primary"
        show={showModal}
        onHide={() => {
          if (!loading) {
            setShowModal(false);
            resetValues();
          }
        }}
        onSubmit={createAppointment}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-notes"></i>
          </div>
          <Button variant="link" className="close-btn" onClick={() => {
            setShowModal(false); resetValues();
          }}>
            <FaTimes style={{color: 'red', fontSize: '1.5rem'}} />
          </Button>
        </Modal.Header>
        {!loading ?
          <div className="modal-body">
            <p className="text-center">{t(translations.APPOINTMENT_MODAL_TITLE)}</p>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group as={Row} controlId="formHorizontalVisiteurF">
                <Form.Label column sm={4}>
                  {t(translations.APPOINTMENT_MODAL_LAST_NAME) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    required
                    maxLength={50}
                    type="Nom"
                    placeholder={t(translations.APPOINTMENT_MODAL_LAST_NAME_LABEL)}
                    value={showVLastName}
                    onChange={(e) => setVLastName(e.currentTarget.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(translations.APPOINTMENT_MODAL_LAST_NAME_ERROR)}
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formHorizontalVisiteurL">
                <Form.Label column sm={4}>
                  {t(translations.APPOINTMENT_MODAL_FIRST_NAME) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    required
                    maxLength={50}
                    type="Prénom"
                    placeholder={t(translations.APPOINTMENT_MODAL_FIRST_NAME_LABEL)}
                    value={showVFirstName}
                    onChange={(e) => setVFirstName(e.currentTarget.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(translations.APPOINTMENT_MODAL_FIRST_NAME_ERROR)}
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
              {showVisitorEmailRequired == true ?
                <>
                  <Form.Group as={Row} controlId="formHorizontalVisiteurF">
                    <Form.Label column sm={4}>
                      {t(translations.VISITOR_EMAIL) + ':'}
                    </Form.Label>
                    <Col sm={8} className="input-with-icon">
                      <Form.Control
                        required={showVisitorEmailRequired}
                        maxLength={100}
                        type="email"
                        placeholder={t(translations.VISITOR_EMAIL_LABEL)}
                        value={showVEmail}
                        onChange={(e) => setVEmail(e.currentTarget.value)}
                        disabled={noEmailChecked}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(translations.EMAIL_ERROR)}
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formHorizontalVisiteurF">
                    <Col sm={8}>
                      <div>
                        <input type="checkbox" id="coding" name="interest" value="coding" onChange={(e) => {
                          setNoEmailChecked(e.target.checked);
                          if (e.target.checked) {
                            handleIconClick();
                            setVEmail('email@email.com'); // Set default value
                          } else {
                            setVEmail(''); // Clear the email field if unchecked
                          }
                        }} />
                        <label htmlFor="coding" style={{marginLeft: 8}}>{t(translations.NO_EMAIL)}</label>
                      </div>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formHorizontalLanguageMail">
                    <Form.Label column sm={4}>{t(translations.LANGUAGE_MAIL)}</Form.Label>
                    <Col sm={8} style={{zIndex: 100}}>
                      <Select
                        isClearable={false}
                        isSearchable={false}
                        components={animatedComponents}
                        value={showLanguageMail}
                        options={[{'value': 'fr', 'label': t(translations.LANGUAGE_MAIL_FR)}, {'value': 'en', 'label': t(translations.LANGUAGE_MAIL_EN)}]}
                        onChange={(e) => setLanguageMail(e)}
                      />
                    </Col>
                  </Form.Group>
                </> : null
              }
              <Form.Group as={Row} controlId="formHorizontalVisiteurF">
                <Form.Label column sm={4}>
                  {t(translations.VISITOR_ENTREPRISE) + ':'}
                </Form.Label>
                <Col sm={8} className="input-with-icon">
                  <Form.Control
                    maxLength={100}
                    type="text"
                    placeholder={t(translations.VISITOR_ENTREPRISE_LABEL)}
                    value={showVEntreprise}
                    onChange={(e) => setVEntreprise(e.currentTarget.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(translations.ENTREPRISE_ERROR)}
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formHorizontalHour">
                <Form.Label column sm={4}>
                  {t(translations.TIME) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <TimePickerComponent required showHour={showHour} setHour={setHour} validated={validated} setModal={setShowModal} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formHorizontalDate">
                <Form.Label column sm={4}>
                  {t(translations.DATE) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <MulptipleDatePickerComponent required showDate={showDate} setDate={setDate} min={showTodayDate} max={showMaxdayDate} validated={validated} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formHorizontalComments">
                <Form.Label column sm={4}>
                  {t(translations.COMMENTARY) + ':'}
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    as="textarea"
                    type="Commentaire"
                    rows={3}
                    maxLength={200}
                    placeholder={t(translations.COMMENTARY)}
                    value={showComments}
                    onChange={(e) => setComments(e.currentTarget.value)}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <>
                  <Button className="btn-fill btn-round col-sm-6" type="submit">{t(translations.CREATE_BUTTON)}</Button> {/* onSubmit={}*/}
                  <Button className="btn-fill btn-round col-sm-6" type="submit" onClick={()=>{
                    setAddAgain(true);
                  }}>{t(translations.ADD_ANOTHER)}</Button> {/* onSubmit={}*/}
                </>
              </Form.Group>
            </Form>
          </div> :
          <div className="modal-body" style={{alignItems: 'center', justifyContent: 'center', width: '100%', display: 'flex'}}>
            <CircularProgress style={{color: '#F6B540'}}/>
          </div>
        }
      </Modal>
    </>
  );
};

export default ModalADDTableList;
